import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { INPUT_COLOR_BORDER } from "../../utils/colors";
import { useTranslationApp } from "../../lib/i18next";
import useOnboardingChecklist from "../../hooks/useOnboardingChecklist";
import OnboardingChecklistTimelineStep from "./OnboardingChecklistTimelineStep";
import OnboardingChecklistProgressBar from "./OnboardingChecklistProgressBar";
import {
  ONBOARDING_CHECKLIST_HEADER_TITLE,
  ONBOARDING_CHECKLIST_SUBTITLE,
  ONBOARDING_CHECKLIST_SKIP_GUIDE,
} from "../../i18n/keysTranslations";

const OnboardingSetupSteps = () => {
  const { t } = useTranslationApp();
  const {
    items,
    completedCount,
    totalItems,
    progress,
    showOnboardingChecklist,
    onActionStep,
    onSkipGuide,
  } = useOnboardingChecklist();

  if (!showOnboardingChecklist) {
    return null;
  }

  return (
    <Box
      sx={{
        mt: 2.5,
        width: "100%",
        bgcolor: "background.paper",
        borderRadius: 3,
        border: "1px solid",
        borderColor: INPUT_COLOR_BORDER,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          px: 3,
          pt: 3,
          pb: 2.5,
          borderBottom: "1px solid",
          borderColor: INPUT_COLOR_BORDER,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: 700,
              color: "text.primary",
            }}
          >
            {t(ONBOARDING_CHECKLIST_HEADER_TITLE)}
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              color: "text.secondary",
              minWidth: "fit-content",
            }}
          >
            {completedCount}/{totalItems}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "space-between",
            gap: 2,
            mt: 0.5,
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              color: "text.secondary",
            }}
          >
            {t(ONBOARDING_CHECKLIST_SUBTITLE)}
          </Typography>
          <Link
            component="button"
            onClick={onSkipGuide}
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              color: "text.secondary",
              textDecoration: "none",
              flexShrink: 0,
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            {t(ONBOARDING_CHECKLIST_SKIP_GUIDE)}
          </Link>
        </Box>

        <OnboardingChecklistProgressBar
          progress={progress}
          barColor="success.main"
          sx={{ mt: 2 }}
        />
      </Box>

      <Box sx={{ px: 3, py: 2.5 }}>
        {items.map((step, index) => (
          <OnboardingChecklistTimelineStep
            key={step.actionKey}
            step={step}
            isLast={index === items.length - 1}
            title={t(step.titleKey)}
            description={t(step.descriptionKey)}
            onActionStep={onActionStep}
          />
        ))}
      </Box>
    </Box>
  );
};

export default OnboardingSetupSteps;
